import React from 'react';
import MenuContent from '../MenuContent';
import NavList from '../NavList';

const WeddingBlock = ({ weddings }) => {

  const {rightMenu, leftMenu} = weddings;

  return (
    <MenuContent className="weddings-block row">
      <div className="weddings-list sm-12">
        <div className="row">
          <NavList className="left-list sm-12 md-12 lg-8">
            <h4>
              <a href={leftMenu.heading.link}>{leftMenu.heading.label}</a>
            </h4>
            <ul className="col-lg-2">
              {leftMenu.links.map((item, index) => (
                <li key={item.label + index} >
                  <a href={item.link}>{item.label}</a>
                </li>
              ))}
            </ul>
          </NavList>
          <NavList className="right-list sm-12 md-12 lg-4">
            {rightMenu.map((item, index) => (
              <h4 key={item.label + index}>
                <a href={item.link}>{item.label}</a>
              </h4>
            ))}
          </NavList>
        </div>
      </div>
      <div className="weddings-promos row sm-12 util-txt-center">
        <a className="promo-block sm-12 lg-7 d-flex" href={weddings.weddingPromotionLink}>
          <i className="icon-weddings d-sm-none d-md-none" />
          <i className="icon-label d-lg-none d-xxl-none" />
          <h5 className="promo-heading">
            <span className="d-xxl-none">Weddings </span>
            Promotions <i className="icon-arrow d-sm-none d-md-none" />
          </h5>
        </a>
        <a className="promo-block sm-12 lg-5 d-flex" href={weddings.createOwnWeddingLink}>
          <i className="icon-book" />

          <h5 className="promo-heading">Create Your Own Wedding</h5>

          <p className="d-sm-none d-md-none">
            Find countless items you can mix and match to create your very own
            vision.
          </p>
        </a>
      </div>
    </MenuContent>
  );
};

export default WeddingBlock;

WeddingBlock.defaultProps = {
  weddings: {},
};



// WEBPACK FOOTER //
// ./js/components/global/menu/menuBlocks/WeddingsBlock.js